'use client'

import { DropdownItem, DropdownLabel } from '@algoacademy/design-system/web/actions/Dropdown'
import { authClient } from '@/app/_auth/auth-client'

const handleLogout = () => {
  void authClient.signOut({
    fetchOptions: {
      onSuccess: () => {
        window.location.href = '/baza'
      }
    }
  })
}

export function LogoutButton() {
  return (
    <DropdownItem onClick={handleLogout} className='data-focus:bg-backgroundRed'>
      <DropdownLabel className='text-contentRed'>Wyloguj się</DropdownLabel>
    </DropdownItem>
  )
}
